export default __webpack_public_path__ + "static/media/hotgig-loading.d72fdd9e.png";